import { cn } from "@/lib/utils"
import { StatTile, type StatTileProps } from "./StatTile"

export type StatItem = StatTileProps

interface StatGridProps {
  items: StatItem[]
  className?: string
}

/**
 * 4-up grid of {@link StatTile}s. Shared by the Material Compliance list views
 * (customer requests, supplier declarations) so the KPI row stays consistent.
 */
export function StatGrid({ items, className }: StatGridProps) {
  return (
    <div className={cn("grid grid-cols-4 gap-3", className)}>
      {items.map((item, i) => (
        <StatTile key={i} {...item} />
      ))}
    </div>
  )
}
